import React from 'react';
import Box from '../box/Box.jsx'
import ListIcon from '../icons/List.icon';
import Title from '../title/Title.jsx';
import TableBox from '../box/TableBox';

export const NoRecords = props => {
  return (
    <TableBox>
      <Box borderBox={false} className="p-3">
        <ListIcon/>
        <div>
          <Title className="p-4 text-center" fontSize={18}>No se han encontrado resultados para su búsqueda.</Title>
        </div>
      </Box>
    </TableBox>
  );
};

NoRecords.propTypes = {};

export default NoRecords;
